export default function PricingCards() {
  return (
    <section className="bg-gray-50 py-10 border-b border-gray-200">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 text-center mb-8">
          無料モックの後も、
プロジェクトの進捗に合わせたプランをご用意しております
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Package S */}
          <div className="bg-white border-2 border-amber-400 rounded-2xl p-6 relative">
            <div className="flex flex-wrap gap-2 mb-3">
              <span className="bg-amber-400 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">キャンペーン限定</span>
              <span className="bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">製造業特化</span>
            </div>
            <div className="text-sm font-semibold text-gray-600 mb-1">パッケージS</div>
            <div className="flex items-end gap-2 mb-1">
              <span className="text-gray-400 line-through text-sm">100万円</span>
            </div>
            <div className="text-3xl font-extrabold text-gray-900">
              50万円<span className="text-sm font-normal text-gray-500 ml-1">(税別)/ 1週間</span>
            </div>
            <div className="text-sm text-gray-500 mt-2">特別限定プラン <span className="text-orange-500 font-semibold">Excel脱却</span></div>
          </div>
          {/* Package A */}
          <div className="bg-white border border-gray-200 rounded-2xl p-6">
            <div className="text-sm font-semibold text-gray-600 mb-1">パッケージA</div>
            <div className="text-3xl font-extrabold text-gray-900 mt-4">
              100万円<span className="text-sm font-normal text-gray-500 ml-1">(税別)/ 1週間</span>
            </div>
            <div className="text-sm text-gray-500 mt-2">技術検証プラン <span className="text-gray-600 font-semibold">小規模検証向け</span></div>
          </div>
          {/* Package B */}
          <div className="bg-white border border-gray-200 rounded-2xl p-6 relative">
            <div className="text-sm font-semibold text-gray-600 mb-1">パッケージB</div>
            <div className="text-3xl font-extrabold text-gray-900 mt-4">
              200万円<span className="text-sm font-normal text-gray-500 ml-1">(税別)/ 2週間</span>
            </div>
            <div className="text-sm text-gray-500 mt-2">超高速MVP検証プラン <span className="text-gray-600 font-semibold">本格導入前検証向け</span></div>
          </div>
        </div>
        <div className="mt-8">
          <a
            href="#contact"
            className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg md:text-xl py-5 md:py-6 rounded-xl transition-all shadow-xl shadow-blue-600/30 hover:shadow-blue-500/50 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            まず、無料のモック作成をご依頼ください&rarr;
          </a>
        </div>
      </div>
    </section>
  );
}
